// eslint-disable-next-line vue/script-setup-uses-vars
/*
 * Copyright (c) 2021. Michael Clovis
 * This program is free software: you can redistribute it and/or modify
 *     it under the terms of the GNU Affero General Public License as published by
 *     the Free Software Foundation, either version 3 of the License, or
 *     (at your option) any later version.
 *
 *     This program is distributed in the hope that it will be useful,
 *     but WITHOUT ANY WARRANTY; without even the implied warranty of
 *     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *     GNU Affero General Public License for more details.
 *
 *     You should have received a copy of the GNU Affero General Public License
 *     along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import moment from "moment";
import {User} from "./User"
import {CheckIn} from "./CheckIn";

export class Appointment {
  DEFAULT_ID = "0";
  startHalfHours = 0;
  halfHours = 0;
  id = this.DEFAULT_ID;
  job = "";
  User = new User("", "", "");
  month = null;
  checkin = new CheckIn();
  validateCheckin = new CheckIn();
  isValidated = false;
  hasClockedOut = false;
  duration = null;
  clockOut = new CheckIn();
  constructor(user, strJob) {
    this.User = user || new User("", "", "");
    this.job = strJob || "";
    let start = new moment();
    const remainder = 30 - (start.minute() % 30);
    start.add(remainder, "minutes");

    this.duration = {start: start, end: start, interval: 0};
    this.setDurationInterval();
  }


  setDurationInterval(){

    this.duration.interval = this.duration.end.diff(this.duration.start,"minutes");
    this.month = this.duration.start.month();
    this.setHalfHours();

  }

  setHalfHours(){

    let startInterval = this.duration.start.diff(this.duration.start.clone().startOf("day"), "minutes");

    this.startHalfHours = (startInterval / 30);
    this.halfHours = (this.duration.interval / 30);
  }
  setDurationStart(durationStart){
    this.duration.start = durationStart;
    this.setDurationInterval();

  }
  isBetweenDurationStartAndEnd(mom){
    return mom.isBetween(this.duration.start,this.duration.end,undefined,[])
  }
  static convertObject(obj){
    let appt = new Appointment();
    Object.assign(appt,obj);
    appt.duration.start = moment(obj.duration.start);
    appt.duration.end =  moment(obj.duration.end);

    appt.User = User.convertObject(obj.User)

    appt.setDurationInterval();
    appt.checkin.time = new moment(obj.checkin.time);
    appt.validateCheckin.time = new moment(obj.validateCheckin.time)


    return appt;

  }
  shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if(object1[key] instanceof User){
        if(!object1[key].isEqual(object2[key])){
          return false;
        }
      }else if(key === "duration"){
        return object1[key].start.toString() === object2[key].start.toString() &&
            object1[key].end.toString() === object2[key].end.toString() &&
            object1[key].interval === object2[key].interval;
      }
      else if (object1[key] !== object2[key]) {
        return false;
      }
    }

    return true;
  }

  isEqual(appt) {
    if (appt instanceof Appointment) {
      return this.shallowEqual(this, appt);

    } else {
      return false;
    }
  }

  isSameDayAndSameUser(user, mom) {
    return this.User.id === user.id && this.isOnSameDayAs(mom);

  }

  isOnSameDayAs(mom) {
    return (mom.startOf("day").unix() <= this.duration.start.unix() &&
        this.duration.start.unix() <= mom.endOf("day").unix()) ||
        (mom.startOf("day").unix() <= this.duration.end.unix() &&
            this.duration.end.unix() <= mom.endOf("day").unix());
  }

  getDurationStart() {
    // let rounder;
    // // get to earlier nearest half hour
    // if (this.duration.start.minutes() > 30){
    //   rounder = this.duration.start.minutes() - 30
    // }else{
    //   rounder = this.duration.start.minutes();
    // }


    return this.duration.start.format("hh:mm A");
  }
  setDurationEnd(durationEnd){

    this.duration.end = durationEnd;
    this.setDurationInterval();
    this.setHalfHours()

  }

  getDurationEnd() {
    // // get nearest next half hour
    // let rounder = 0;
    // // get to earlier nearest half hour
    // if (this.duration.end.minutes() >= 30){
    //   rounder = this.duration.end.minutes() - 30
    // }else{
    //   rounder = this.duration.end.minutes();
    // }
    //const rounder = 30 - (this.duration.end.minutes() % 30)
    return this.duration.end.format("hh:mm A");
  }
  getUserFullName(){
    return this.User.getFullName();
  }
  isBetween(moment1,moment2){
    return this.duration.start.isBetween(moment1,moment2,undefined,"[]") ||
        this.duration.end.isBetween(moment1,moment2,undefined,"[]");
  }


  // toJSON(){
  //   return JSON.stringify(this);
  // }


}

// Appointment.prototype.toJSON = function(){
//
// }
